<!--<template>-->
<!--  <div style="text-align: center">-->

<!--    <Row type="flex" :gutter="40" justify="space-between" style="margin-top: 5px">-->
<!--      <Col span="12">-->
<!--        <Card class="card-container mb-40">-->
<!--          <h2 class="mb-24">Выручка</h2>-->
<!--          <revenueChart></revenueChart>-->
<!--        </Card>-->
<!--      </Col>-->
<!--      <Col span="12">-->
<!--        <Card class="card-container mb-40">-->
<!--          <h2 class="mb-24">Оплаты</h2>-->
<!--          <paymentType></paymentType>-->
<!--        </Card>-->
<!--      </Col>-->

<!--      <Col span="12">-->
<!--        <Card class="card-container">-->
<!--          <h2 class="mb-24">Транзакции</h2>-->
<!--          <Row class="mb-40" type="flex" align="center" justify="space-between">-->
<!--            <div class="large-title">Средний чек:</div>-->
<!--            <averageOrderChart></averageOrderChart>-->
<!--          </Row>-->
<!--          <Row type="flex" align="center">-->
<!--            <Button type="success">-->
<!--              <span class="d-flex align-center">-->
<!--                <img src="/static/svg/download.svg" alt="" style="margin-right: 8px">-->
<!--                Скачать выписку-->
<!--              </span>-->
<!--            </Button>-->
<!--          </Row>-->

<!--        </Card>-->

<!--      </Col>-->

<!--      <Col span="12">-->
<!--        <div class="card-container">-->
<!--          <h2 class="p-16 mb-24">Ходовой товар</h2>-->
<!--          <topProductsChart></topProductsChart>-->

<!--        </div>-->
<!--      </Col>-->


<!--    </Row>-->

<!--&lt;!&ndash;    <Row type="flex" justify="space-between" style="margin-top: 50px">&ndash;&gt;-->
<!--&lt;!&ndash;      <Col span="5" v-for="item in buttons" :key="item.msg">&ndash;&gt;-->
<!--&lt;!&ndash;        <Card&ndash;&gt;-->
<!--&lt;!&ndash;          class="button_card"&ndash;&gt;-->
<!--&lt;!&ndash;          @click.native="&ndash;&gt;-->
<!--&lt;!&ndash;            $router.push({ name: item.view_name, query: item.params })&ndash;&gt;-->
<!--&lt;!&ndash;          "&ndash;&gt;-->
<!--&lt;!&ndash;        >&ndash;&gt;-->
<!--&lt;!&ndash;          <div&ndash;&gt;-->
<!--&lt;!&ndash;            style="text-align:center; margin: 35px 0;color: rgba(0, 121, 189, 0.93);"&ndash;&gt;-->
<!--&lt;!&ndash;          >&ndash;&gt;-->
<!--&lt;!&ndash;            <h2>{{ item.msg }}</h2>&ndash;&gt;-->
<!--&lt;!&ndash;            <Divider&ndash;&gt;-->
<!--&lt;!&ndash;              style="background-color: rgba(0, 121, 189, 0.93);"&ndash;&gt;-->
<!--&lt;!&ndash;            ></Divider>&ndash;&gt;-->
<!--&lt;!&ndash;            {{ item.description }}&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </Card>&ndash;&gt;-->
<!--&lt;!&ndash;      </Col>&ndash;&gt;-->
<!--&lt;!&ndash;    </Row>&ndash;&gt;-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--import topProductsChart from "./topProductsChart";-->
<!--import averageOrderChart from "./averageOrderChart";-->
<!--import revenueChart from "./revenueChart";-->
<!--import paymentType from "./paymentType";-->
<!--export default {-->
<!--  name: "home",-->
<!--  components: {-->
<!--    topProductsChart,-->
<!--    averageOrderChart,-->
<!--    revenueChart,-->
<!--    paymentType-->
<!--  },-->
<!--  data() {-->
<!--    return {-->
<!--      // buttons: [-->
<!--      //   {-->
<!--      //     msg: "Добавление товара",-->
<!--      //     description:-->
<!--      //       "Переход в форму добавления нового товара, услуги либо комплекта",-->
<!--      //     view_name: "catalog_create",-->
<!--      //     params: {}-->
<!--      //   },-->
<!--      //   {-->
<!--      //     msg: "Продажа",-->
<!--      //     description: "Переход в форму создания заказа",-->
<!--      //     view_name: "product_order_create",-->
<!--      //     params: { type: "sale" }-->
<!--      //   },-->
<!--      //   {-->
<!--      //     msg: "Списание",-->
<!--      //     description: "Переход в форму списания товаров",-->
<!--      //     view_name: "product_order_change_out_create",-->
<!--      //     params: {}-->
<!--      //   },-->
<!--      //   {-->
<!--      //     msg: "Отчеты",-->
<!--      //     description: "Просмотр отчетов",-->
<!--      //     view_name: "report",-->
<!--      //     params: {}-->
<!--      //   }-->
<!--      // ]-->
<!--    };-->
<!--  }-->
<!--};-->
<!--</script>-->

<!--<style scoped>-->
<!--.button_card {-->
<!--  width: 100%;-->
<!--  background-color: rgba(143, 208, 245, 0.27);-->
<!--  min-height: 230px;-->
<!--  cursor: pointer;-->
<!--}-->
<!--.card-container {-->
<!--  padding: 20px;-->
<!--  text-align: left;-->
<!--}-->
<!--.card-container .large-title{-->
<!--  font-size: 30px;-->
<!--}-->
<!--  .p-16 {-->
<!--    padding-left: 16px;-->
<!--    padding-right: 16px;-->
<!--  }-->

<!--</style>-->




<template>
  <div style="text-align: center">
    <!--    <h1>{{ msg }}</h1>-->

    <Row
      type="flex"
      justify="space-around"
      style="margin-top: 10px"
      :gutter="24"
    >
      <Col :xs="24" :sm="24" :md="24" :lg="12" :xl="14" :xxl="13" class="mb-40 m">
        <revenueBar></revenueBar>
      </Col>
      <Col :xs="24" :sm="24" :md="24" :lg="12" :xl="10" :xxl="11" class="mb-40">
        <paymentType2></paymentType2>
      </Col>


      <Col :xs="24" :sm="24" :md="24" :lg="12" :xl="14" :xxl="13" class="mb-40">
        <topProductsTable></topProductsTable>
      </Col>


      <Col :xs="24" :sm="24" :md="24" :lg="12" :xl="10" :xxl="11">
        <averageOrderChart2></averageOrderChart2>
      </Col>
    </Row>

  </div>
</template>

<script>
    import topProductsChart from "./topProductsChart";
    import averageOrderChart2 from "./averageOrderChart2";
    import revenueChart2 from "./revenueChart2";
    import paymentType2 from "./paymentType2";
    import topProductsTable from "./topProductsTable";
    import revenueBar from "./revenueBar";
    export default {
        name: "home",
        components: {
            topProductsChart,
            averageOrderChart2,
            revenueChart2,
            paymentType2,
            topProductsTable,
            revenueBar
        },
        data() {
            return {
                msg: "Добро пожаловать в товаро-учетную систему Light Shop!"
                // buttons: [
                //   {
                //     msg: "Добавление товара",
                //     description:
                //       "Переход в форму добавления нового товара, услуги либо комплекта",
                //     view_name: "catalog_create",
                //     params: {}
                //   },
                //   {
                //     msg: "Продажа",
                //     description: "Переход в форму создания заказа",
                //     view_name: "product_order_create",
                //     params: { type: "sale" }
                //   },
                //   {
                //     msg: "Списание",
                //     description: "Переход в форму списания товаров",
                //     view_name: "product_order_change_out_create",
                //     params: {}
                //   },
                //   {
                //     msg: "Отчеты",
                //     description: "Просмотр отчетов",
                //     view_name: "report",
                //     params: {}
                //   }
                // ]
            };
        }
    };
</script>

<style scoped>
  .button_card {
    width: 100%;
    background-color: rgba(143, 208, 245, 0.27);
    min-height: 230px;
    cursor: pointer;
  }
  .chart_card {
    width: 100%;
    background-color: rgba(238, 238, 238, 0.45);
    /*min-height: 230px;*/
    /*cursor: pointer;*/
  }



</style>



// WEBPACK FOOTER //
// src/apps/home/home.vue